import React, { useEffect, useState } from "react";
import { Form, Skeleton, message, Row, Col } from "antd";
import { SaveButton, CancelButton, ModalComponent, trans, InputTime, InputDate, InputTextArea, SelectWithSearch, SelectResourceList } from "@comps/components"
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { createDataReq, getRelatedDataReq } from "../requests";
import { Commons, Const } from "../../constants";
import { getEmployeesDataReq } from "@mods/common/requests";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { attendanceTooltips } from "../../common/attendanceTooltips";

const langKey = Const["attendanceLogs"].lngKey

const fieldLabel = makeFieldLabel(attendanceTooltips.attendanceLog, { namespace: "attendanceLog", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createAttendanceRequest";
const CreateAttendanceLogs = (props) => {
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [punchTypes, setPunchTypes] = useState([])
  const [form] = Form.useForm()
  useEffect(() => {
    getEmployments()
    getRelatedData()
    // eslint-disable-next-line
  }, []);

  const getRelatedData = () => {
    makeRequest(setLoader, getRelatedDataReq, null, setRelatedData, null);
  }

  const getEmployments = () => {
    const payload = { filters: null }
    makeRequestStateless(getEmployeesDataReq, payload, onGetEmployments, false)
  }
  const onGetEmployments = (response) => {
    setLoading(false)
  }

  const setRelatedData = (response) => {
    const punchTypeList = [];
    if (response.punch_types !== undefined) {
      response.punch_types.forEach(each => {
        punchTypeList.push({
          label: each.name,
          value: each.name
        })
      })
    }
    setPunchTypes(punchTypeList)
  }

  const onSubmit = (data) => {
    const payload = {
      attendance_log: {
        employee_id: data.employee_id,
        punch_type: data.punch_type,
        punch_date: data.punch_date,
        punch_time: data.punch_time.year(data.punch_date.year()).month(data.punch_date.month()).date(data.punch_date.date()).second(0),
        description: data.description
      }
    }
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
    setSaveLoader(true)
  }
  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.attendance_logs.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {

    setSaveLoader(false)
    message.error(res.response.data.message);
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------
  return (
    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit } scrollToFirstError>
          <Row gutter={ 30 } scrollToFirstError>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>

              <Form.Item name="employee_id" rules={ rules.employment_id } label={ fieldLabel("employee_id", trans(`${langKey}.employment_id`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectResourceList type='employee' />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="punch_type" rules={ rules.punch_type } label={ fieldLabel("punch_type", trans(`${langKey}.punch_type`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectWithSearch
                  options={ punchTypes }
                  placeholder={ trans(`${langKey}.punch_type`) }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="punch_date" rules={ rules.punch_date } label={ fieldLabel("punch_date", trans(`${langKey}.punch_date`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['punch_date']) } size="small"
              >
                <InputDate />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="punch_time" rules={ rules.punch_time } label={ fieldLabel("punch_time", trans(`${langKey}.punch_time`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['punch_time']) } size="small"
              >
                <InputTime placeholder={ trans(`${langKey}.punch_time`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="description" rules={ rules.description } label={ fieldLabel("description", trans(`${langKey}.description`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['description']) } size="small"
              >
                <InputTextArea placeholder={ trans(`${langKey}.description`) } />
              </Form.Item>
            </Col>
          </Row>

        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default CreateAttendanceLogs

const rules = {
  punch_date: [
    { required: true, message: trans(`${langKey}.punch_date.req`) },
  ],
  punch_time: [
    { required: true, message: trans(`${langKey}.punch_time.req`) },
  ],
  punch_type: [
    { required: true, message: trans(`${langKey}.punch_type.req`) },
  ],
  employment_id: [
    { required: true, message: trans(`${langKey}.employment_id.req`) },
  ],
  // description: [
  //   { required: true, message: trans(Commons.description) },
  // ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}

